<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: ContactCta                                           |
| Section: components                                             |
| Purpose: Shared above-footer call-to-action container.           |
+------------------------------------------------------------------+
-->
<template>
    <div class="ContactCta">
        <div class="ContactCta_wrapper wrapper">
            <div class="ContactCta_content">
                <h2>{{ resolvedHeading }}</h2>
                <div class="ContactCta_actions">
                    <BtnPrimary :label="resolvedButtonLabel" :href="resolvedHref"
                        iconFillColor="var(--brand-text-light)" />
                    <BtnPrimary v-if="secondaryButtonLabel && secondaryHref" :label="secondaryButtonLabel"
                        :href="secondaryHref" iconFillColor="var(--brand-text-light)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BtnPrimary from '@/atoms/BtnPrimary.vue';
import { useLocale } from '@/composables/useLocale';

export default {
    name: 'ContactCta',
    components: {
        BtnPrimary,
    },
    props: {
        heading: {
            type: String,
            default: '',
        },
        buttonLabel: {
            type: String,
            default: '',
        },
        href: {
            type: String,
            default: '',
        },
        secondaryButtonLabel: {
            type: String,
            default: '',
        },
        secondaryHref: {
            type: String,
            default: '',
        },
    },
    setup() {
        const { localePath } = useLocale();
        return { localePath };
    },
    computed: {
        resolvedHeading() {
            return this.heading || this.$t('aboutPage.cta.heading');
        },
        resolvedButtonLabel() {
            return this.buttonLabel || this.$t('aboutPage.cta.button');
        },
        resolvedHref() {
            return this.href || this.localePath('/contact');
        },
    },
};
</script>

<style scoped>
.ContactCta {
    background: url('@/assets/noise128x128.png'), linear-gradient(to bottom, var(--brand-bg-2) 50%, var(--brand-bg-4) 50%);
    background-repeat: repeat;
    background-size: auto;
    background-position: center, center;
    transition: var(--transition-bounce);
}

.ContactCta_wrapper {
    padding-left: 20px;
    padding-right: 20px;
}

.ContactCta_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    padding: 96px;
    background-color: var(--brand-bg-1);
    border-radius: var(--border-radius-xl);
    box-shadow: var(--shadow-card-sm);
    text-align: center;
}

.ContactCta_actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: fit-content;
    margin: 0 auto;
}

@media (max-width: 860px) {
    .ContactCta_content {
        padding: 72px 24px;
    }
}
</style>
